import { PageIcon } from './PageIcon.js';

interface PageHeaderProps {
  title: string;
  icon: string | null;
  cover: string | null;
}

export function PageHeader({ title, icon, cover }: PageHeaderProps) {
  return (
    <header>
      {cover && (
        <div className="w-full h-48 overflow-hidden">
          <img src={cover} alt="" className="w-full h-full object-cover" />
        </div>
      )}
      <div className="px-12 pt-12 pb-6 max-w-4xl mx-auto">
        {icon && (
          <div className="mb-3 text-5xl leading-none">
            <PageIcon icon={icon} size="xl" />
          </div>
        )}
        <h1 className="text-4xl font-display font-bold text-brand-800">
          {title || 'Untitled'}
        </h1>
      </div>
    </header>
  );
}
